'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTram = function MdTram(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 23.4v-8.4h-16.8v8.4h16.8z m-8.4 7.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m11.6-2.7c0 2.8-1.4 5.2-4.3 5.2h0.2l2.5 2.5v0.7h-3.4l-3.2-3.2h-6.4l-3.2 3.2h-3.8v-0.7l2.7-2.7c-2.4-0.5-4.3-2.6-4.3-5v-14.1c0-4.6 4.7-5.6 9.9-5.7l1.3-2.5h-8v-2.5h16.8v2.5h-5.5l-1.3 2.5c5.7 0.1 10 1.1 10 5.7v14.1z' })
        )
    );
};

exports.default = MdTram;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/tram.js
// module id = 1289
// module chunks = 0